export const normalizeDateForInput = (date) => {
  if (!date) return "";

  // kalau sudah format YYYY-MM-DD, langsung pakai
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }

  // handle format D/M/YYYY atau DD/MM/YYYY
  const parts = date.split("/");
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  return "";
};